import { render } from "./shell.vue?vue&type=template&id=4f5a61eb"
import script from "./shell.vue?vue&type=script&lang=js"
export * from "./shell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__